export const STATS = [
  { id: 1, title: '12 334', description: 'веб\nмастеров' },
  { id: 2, title: '10 млн', description: 'конверсий' },
  { id: 3, title: '10 млрд', description: 'выручка\nвеб мастеров' },
];
